import gql from 'graphql-tag'

export const countries = gql`
  query {
    countries: elements(
      where: { iblock: { code: { equals: "countryList" } } }
    ) {
      name
      updatedAt
      propertyValuesRelation {
        targetElement {
          propertyValues {
            value
            property {
              code
            }
          }
        }
      }
    }
  }
`
